export { RegistrationForm } from './registration-form';
export type { TRegistrationFormData } from './registration-form';
export { registrationFormI18n } from './registration-form.i18n';
